// extracted by mini-css-extract-plugin
export default {"testSearch":"T-DR85oHlZGR6voSQmJG9","text-map":"_23EhfcgOLud4anrjBMNgej","col-lg-8":"_1DEwoKXLDiObY5_-Axb8dY","col-lg-4":"_3WwPLxKSDw1lK8zyhVGIng","svg":"_20B-I7NOFoPCakTnEwVgUZ"};